import * as Sentry from "@sentry/react";

/**
 * Utility functions for Sentry error reporting
 */

/**
 * Capture an exception and send it to Sentry
 * @param error - The error object to capture
 * @param context - Additional context to include with the error
 */
export const captureException = (error: Error, context?: Record<string, any>): void => {
  Sentry.captureException(error, {
    extra: context,
  });
};

/**
 * Capture a message and send it to Sentry
 * @param message - The message to capture
 * @param level - The severity level of the message
 * @param context - Additional context to include with the message
 */
export const captureMessage = (
  message: string,
  level: Sentry.SeverityLevel = "info",
  context?: Record<string, any>
): void => {
  Sentry.captureMessage(message, {
    level,
    extra: context,
  });
};

/**
 * Set user information for Sentry
 * @param id user id
 * @param email user optional email
 */
export const setSentryUser = (id: string, email?: string): void =>  {
  Sentry.setUser({id: id, email: email});
};

/**
 * Set tags for Sentry
 * @param tags - The tags to set
 */
export const setTags = (tags: Record<string, string>): void => {
  Object.entries(tags).forEach(([key, value]) => {
    Sentry.setTag(key, value);
  });
};

/**
 * Add breadcrumb for Sentry
 * @param breadcrumb - The breadcrumb to add
 */
export const addBreadcrumb = (breadcrumb: Sentry.Breadcrumb): void => {
  Sentry.addBreadcrumb(breadcrumb);
};